import React, { useEffect, useState } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import Loading from '../components/Loading';
import Loader from '../components/Loader';

function RenewalHistory() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMySubscriptions = async () => {

      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          url: `${params.baseURL}${params.endpoints.renewalHistory}`,
          data: formData
        });

        if (response.data.items && Array.isArray(response.data.items)) {
          console.log(response.data);
          setData(response.data.items);
        } else {
          setError(response.message || 'Error in fetching data.');
        }
      } catch (error) {
        return <div>
          <div className='text-center text-uppercase'>
              <img src='/assets/img/no_subscription_found.png' alt='' style={{width:'300px'}} className='img-fluid' />
              <h4>SUBSCRIPTION LOADING ERROR</h4>
            </div>
        </div>
      } finally {
        setLoading(false);
      }
    };

    fetchMySubscriptions();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div className='ms-section'>
      {data.length > 0 ? (<>
        {data.map(item => (
            <div className='ms-box'>
                <div className='ms-box-header'>
                    <h4>{item.subscription_name} -
                      <span className='ms-price-title'> {item.subscription_final_rate_display} {item.renewed_final_rate_display} {item.days_in_month}</span>
                    </h4>                               
                    <div className='ms-body-flex-item'>
                        <p className='ms-purchase-status active'>{item.renewal_status_display}</p>
                        <a href={item.invoice_link} target='_blank' className={'ms-purchase-status'} style={{background:'#000',color:'#fff'}}>Invoice</a>
                    </div>
                </div>
                <div className='ms-box-footer'>
                    <div className='ms-body-flex-item d-block'>
                        <p>For Period : {item.allowed_period}</p>
                        <p>Requested on : {item.renew_request_time}</p>
                        <p>Renewed on : {item.renewed_on_display}</p>
                    </div>
                </div>
            </div>
        ))}
        </>) : (<>
          <div className='text-center text-uppercase'>
            <img src='/assets/img/banners/no_renewal_history.webp' alt='' style={{width:'500px'}} className='img-fluid' />
          </div>
        </>)}
      </div>
    </div>
  )
}

export default RenewalHistory;